import React from 'react';
import { Github, Rocket } from 'lucide-react';
import { Button } from '@/ui/Button';
import { InstallationStatus } from '@/shared/services/supabaseService';
import { UserProfile } from '@/lib/supabase';

interface ConnectRepositoryAlertProps {
  installationStatus: InstallationStatus | null;
}

export const ConnectRepositoryAlert: React.FC<ConnectRepositoryAlertProps> = ({ installationStatus }) => {
  const handleConnectGitHub = () => {
    if (installationStatus?.installation_url) {
      window.location.href = installationStatus.installation_url;
    }
  };

  return (
    <div className="flex flex-col md:flex-row items-center justify-between gap-4 p-4 border border-neutral-950 dark:border-neutral-100 bg-background shadow-sm hover:bg-neutral-50 dark:hover:bg-neutral-900/50 transition-colors">
      <div className="flex items-center gap-4">
         <div className="p-2 bg-neutral-100 dark:bg-neutral-800 border border-neutral-950 dark:border-neutral-100">
             <Github className="h-5 w-5" />
         </div>
         <div>
            <div className="flex items-center gap-2 mb-1">
                <span className="text-[10px] font-mono font-bold uppercase tracking-wider bg-neutral-950 text-neutral-50 dark:bg-neutral-100 dark:text-neutral-950 px-1.5 py-0.5">
                    ACTION_REQUIRED
                </span>
                <span className="font-mono font-bold text-sm uppercase">Connect Repository</span>
            </div>
            <p className="font-mono text-xs text-muted-foreground">
                Establish connection with GitHub to initialize telemetry.
            </p>
         </div>
      </div>

      <Button
            onClick={handleConnectGitHub}
            size="sm"
            className="w-full md:w-auto rounded-none font-mono font-bold uppercase tracking-wider border border-neutral-950 dark:border-neutral-100 bg-white dark:bg-black text-foreground hover:bg-neutral-100 dark:hover:bg-neutral-900"
        >
            [ CONNECT ]
      </Button>
    </div>
  );
};

interface UpgradeAlertProps {
  userData: UserProfile | null;
}

export const UpgradeAlert: React.FC<UpgradeAlertProps> = ({ userData }) => {
  const checkoutUrl = userData?.id
    ? `https://codiidev.lemonsqueezy.com/buy/77b9e783-f8ab-4778-a05c-ecc78576ed83?checkout[custom][user_id]=${userData.id}`
    : `https://codiidev.lemonsqueezy.com/buy/77b9e783-f8ab-4778-a05c-ecc78576ed83`;

  return (
    <div className="flex flex-col md:flex-row items-center justify-between gap-4 p-4 border border-green-600 dark:border-green-500 bg-green-50/30 dark:bg-green-900/10 hover:bg-green-50/50 dark:hover:bg-green-900/20 transition-colors">
      <div className="flex items-center gap-4">
         <div className="p-2 bg-green-100 dark:bg-green-900/30 border border-green-600 dark:border-green-500 text-green-700 dark:text-green-300">
             <Rocket className="h-5 w-5" />
         </div>
         <div>
            <div className="flex items-center gap-2 mb-1">
                <span className="text-[10px] font-mono font-bold uppercase tracking-wider bg-green-600 text-white dark:bg-green-500 dark:text-black px-1.5 py-0.5">
                    SYSTEM_UPGRADE
                </span>
                <span className="font-mono font-bold text-sm uppercase text-green-800 dark:text-green-200">Unlock Full Power</span>
            </div>
            <p className="font-mono text-xs text-green-700 dark:text-green-300">
                Upgrade to Dev plan for Claude 3.5 Sonnet & unlimited scans.
            </p>
         </div>
      </div>

      <Button
            asChild
            size="sm"
            className="w-full md:w-auto rounded-none font-mono font-bold uppercase tracking-wider bg-green-600 hover:bg-green-700 text-white dark:bg-green-500 dark:hover:bg-green-600 border-none shadow-sm"
        >
            <a href={checkoutUrl} className="lemonsqueezy-button">
                [ UPGRADE ]
            </a>
      </Button>
    </div>
  );
};
